export default {
  setCreateEmailSignatureLoading(state, isCreateEmailSignatureLoading) {
    state.isCreateEmailSignatureLoading = isCreateEmailSignatureLoading;
  },
  setVerifyEmailSignatureLoading(state, isVerifyEmailSignatureLoading) {
    state.isVerifyEmailSignatureLoading = isVerifyEmailSignatureLoading;
  },
  setFetchVanityEmailDomainsLoading(state, isFetchVanityEmailDomainsLoading) {
    state.isFetchVanityEmailDomainsLoading = isFetchVanityEmailDomainsLoading;
  },
  setRetrieveVanityEmailDomainsLoading(state, isRetrieveVanityEmailDomainsLoading) {
    state.isRetrieveVanityEmailDomainsLoading = isRetrieveVanityEmailDomainsLoading;
  },
  setIsVerifyButtonClicked(state, isVerifyButtonClicked) {
    state.isVerifyButtonClicked = isVerifyButtonClicked;
  },
  setIsVerificationPending(state, isVerificationPending) {
    state.isVerificationPending = isVerificationPending;
  },
  setVanityEmailDomains(state, vanityEmailDomains) {
    state.vanityEmailDomains = vanityEmailDomains;
  },
  setDeleteEmailSignatureLoading(state, isDeleteEmailSignatureLoading) {
    state.isDeleteEmailSignatureLoading = isDeleteEmailSignatureLoading;
  },
  setIsOpenConnectDomainDrawer(state, isOpenConnectDomainDrawer) {
    state.isOpenConnectDomainDrawer = isOpenConnectDomainDrawer;
  },
  setSection(state, { sectionId, moduleId }) {
    state.currentModuleId = moduleId;
    state.currentSectionId = sectionId;
  },
  setVanityEmailDomain(state, vanityEmailDomain) {
    state.vanityEmailDomain = vanityEmailDomain;
  },
  setIsCurrentModuleInvalid(state, isCurrentModuleInvalid) {
    state.isCurrentModuleInvalid = isCurrentModuleInvalid;
  }
};
